export default __webpack_public_path__ + "static/img/homepage-fg.ea3d288.png";